import { render, staticRenderFns } from "./download-or-preorder.vue?vue&type=template&id=5ed09838"
import script from "./download-or-preorder.vue?vue&type=script&lang=js"
export * from "./download-or-preorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalBuy: require('/usr/src/app/components/modal/buy.vue').default,ModalBasic: require('/usr/src/app/components/modal/basic.vue').default})
